import React, {useEffect, useMemo, useRef, useState} from "react";
import {useForm} from "react-hook-form";
import {AxiosError} from 'axios';
import axios from '../Utilities/axios.ts';
import {EmailContact, SubjectFields} from "../Components/EmailComponents.ts";
import {ClientEmailInput, Subject} from "../Components/EmailComponents.tsx";
import {createRoot} from "react-dom/client";
import {Contact, Staff} from "../Components/BaseTypes.ts";
import TransmittalApproval, {TransmittalApprovalDto} from "./TransmittalApproval.tsx";
import {toast} from "react-toastify";
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// axios.defaults.maxRedirects = 0;
export interface transmittalSendDto {
    // permissions: ProposalPermissions,
    fromEmail: string,
    transmittalHtml: string
    dateEmailed: string,
    dateApproved: string,
    recipientContactIds: number[],
    staffList: Staff[],
    transmittalId: number,
    subjectFields: SubjectFields,
    emailCCRecipients: string,
    approvalDto: TransmittalApprovalDto,
    version: number,
    issueList: string[]
}

interface SendEmailProps extends transmittalSendDto {
    rootUrl: string,
    sendEnabled: boolean,
    approveEnabled: boolean,
    open: boolean,
    currentStaffEmail: string,
    contactList: Contact[],
    customRecipientEmailAddresses: string[]
}


export function SendEmail({
                              sendEnabled,
                              approveEnabled,
                              transmittalHtml,
                              dateApproved,
                              dateEmailed,
                              rootUrl,
                              recipientContactIds,
                              contactList,
                              staffList,
                              subjectFields,
                              transmittalId,
                              emailCCRecipients,
                              fromEmail,
                              open,
                              issueList,
                              currentStaffEmail,
                              customRecipientEmailAddresses,
                              ...props
                          }: SendEmailProps) {
    const formRef = useRef();
    const [loading, setLoading] = useState(false);

    const {value, ...approvalProps} = props.approvalDto;

    const [currentApprovalStatus, setCurrentApprovalStatus] = useState(props.approvalDto.value);


    const {handleSubmit, register, getValues, setValue, formState: {isDirty}} =
        useForm({
            defaultValues: {
                'recipients': [
                    ...recipientContactIds
                        .filter(c => c > 0)
                        .map(id => contactList.find(contact => contact.pkContactid == id)?.conEmail),
                    ...customRecipientEmailAddresses.map(v => v.trim()).filter(v => v != '') ]
                    .join(', '),
                'emailCCRecipients': emailCCRecipients,
                'emailSubject': subjectFields.body,
                'attachments': null,
                'approvalRequests': [value?.approvalStatus ? value : {
                    id: Math.floor((Math.random() * 1000000) + 1),
                    approvalStatus: 'Awaiting Approval',
                }]
            },
            mode: 'onChange',
        });

    const emailContactList: EmailContact[] = [
        ...contactList.map(c => ({
            'name': c.conFirstname + ' ' + c.conLastname,
            'email': c.conEmail
        })),
        ...staffList.map(s => ({
            'name': s.firstName + ' ' + s.lastName,
            'email': s.stfBusEmail
        })),
    ];


    const onSubmit = (e) => {
        setLoading(true);

        const newone = new FormData(formRef.current);

        axios.post(`${rootUrl}/manageSubmission`, new FormData(formRef.current), {loadingMessage: 'disable'}).then((res) => {
            setLoading(false);
            toast.success(res?.data?.message);
            dialogRef.current.close();
            // @ts-expect-error not typed
            window.renderTransmittalItemSelectionWidget(res.data);

        }).catch((err: AxiosError) => {
            setLoading(false);
            const res = err.response;
            toast.error(`ERROR: ${res?.data?.message || err?.response?.data?.detail || err?.message || err}`)
            dialogRef.current.close();
            // @ts-expect-error not typed
            res?.data?.version && window.renderTransmittalItemSelectionWidget(res.data);
        });
    }
    const dialogRef: React.MutableRefObject<HTMLDialogElement> = useRef();

    useEffect(() => {
        if (open && dialogRef) {
            dialogRef.current.showModal();
        }
    }, [dialogRef]);

    const defaultApprovalValue = useMemo(() => value?.approvalStatus ? currentApprovalStatus : {
            id: Math.floor((Math.random() * 1000000) + 1),
            approvalStatus: 'Awaiting Approval',
        }, []
    )
    const TransmittalApprovalEl =
        useMemo(() => <TransmittalApproval
            {...approvalProps}
            // @ts-expect-error ... Cmon TS
            value={defaultApprovalValue}
            onChange={(e) => {
                setCurrentApprovalStatus({
                    ...currentApprovalStatus,
                    [e.target.name.replace(/.*\[.*]\[(.*)\]/, "$1")]: e.target.value
                });
            }}
            name='approvalRequests'

        />, [value, currentApprovalStatus]);


    return (
        <div>
            {/*<div>*/}
            <button
                // disabled={disabled}
                type='button' className='button' onClick={() => {
                if (window.onbeforeunload) {
                    window.alert('Transmittal changes must be saved before an email can be prepared');
                    return false;
                }
                dialogRef.current.showModal();
            }}>
                Manage Transmittal Submission... {!!dateEmailed && ' (Re-Send)'}
            </button>

            <dialog ref={dialogRef}
                    onClick={(e) => e.target.nodeName === 'DIALOG' && dialogRef.current.close()}
                    className={'sendEmailDialog bg-white shadow-lg h-100 border-0 p-0 overflow-hidden'}
                    style={{width: '80em', maxWidth: '100vw', zIndex: '9999999999999999', maxHeight: '100vh'}}

            >
                <div className='px-2 px-md-4 py-2 py-md-3'>
                    <form id='submissionForm' ref={formRef} onSubmit={handleSubmit(onSubmit)} method='POST'
                          onChange={(e) => e.stopPropagation()} className='d-flex flex-column h-100'>
                        {/*<Dialog.Close className={'btn btn-close float-end'}></Dialog.Close>*/}
                        <div className='d-flex mt-2'>
                            <h3 className='m-0' style={{flexGrow: 1}}>
                                Manage Transmittal Submission
                            </h3>
                            <input type='submit' form='submissionForm' className='button'
                                   disabled={loading || (!sendEnabled && !approveEnabled)}
                                   value={
                                       loading ?
                                           'Processing...' :
                                           currentApprovalStatus.approvalStatus === 'Approved' && sendEnabled &&
                                           (currentApprovalStatus.requestedApprover.id === approvalProps.currentStaffId || props.approvalDto.value.approvalStatus === 'Approved') ?
                                               'Email Transmittal' :
                                               props.approvalDto.value?.approvalStatus != 'Approved' &&
                                               currentApprovalStatus?.requestedApprover?.callName != props.approvalDto.value?.requestedApprover?.callName ?
                                                   'Save & Request Approval' :
                                                   'Save Email/Approval Data'
                                   }
                                   style={{height: 30, marginRight: '1.5em'}}/>
                            <button type='button' className={'btn btn-close pe-3 pe-md-1'}
                                    onClick={() => dialogRef.current.close()}></button>
                        </div>
                        <div className="mt-2 proposalSubmission flex-grow-1 d-flex flex-column">
                            {/*<Form action={`${rootUrl}/send`} control={control} headers={{"Content-Type": "multipart/form-data"}} >*/}
                            {dateApproved && !sendEnabled && approveEnabled &&
                                <span className="bg-warning-subtle p-1">Transmittal can no longer be submitted (even though it has been approved) because of verification issues. To resend, these issues must first be resolved:</span>}
                            {!sendEnabled && !approveEnabled &&
                                <span className="bg-warning-subtle p-1">Transmittal can not be submitted due to the following issues: </span>}
                            {
                                !sendEnabled &&
                                <ul className="bg-warning-subtle p-1 ps-3">
                                    {
                                        issueList.map(issue => <li>{issue}</li>)
                                    }
                                </ul>
                            }
                            <div
                                className="d-grid gap-1 mb-1"
                                style={{gridTemplateColumns: 'repeat(auto-fit, minmax(25rem, 1fr)'}}
                            >
                                <div className="border p-2" onChange={() => console.log('inner change')}>
                                    <fieldset disabled={!approveEnabled}>
                                        {TransmittalApprovalEl}
                                    </fieldset>
                                </div>
                            </div>
                            <input type='hidden' name='version' value={props.version || 0}/>
                            <fieldset disabled={!sendEnabled}>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='from' className='pe-2'
                                           style={{width: '5em', minWidth: '5em'}}>From:</label>
                                    <select id='from' className="form-select mb-sm-1" defaultValue={fromEmail}
                                            name='emailFrom'>
                                        <option value={fromEmail}>{fromEmail}</option>
                                        {(fromEmail != currentStaffEmail) &&
                                            <option value={currentStaffEmail}>{currentStaffEmail}</option>}
                                    </select>
                                    {/*<span className='form-control w-auto border-0'>{fromEmail}</span>*/}
                                </div>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='to' className='pe-2' style={{width: '5em'}}>To:</label>
                                    <input {...register('recipients')}
                                           style={{width: 'auto'}}
                                           className="form-control mb-sm-1 flex-fill"
                                           disabled={true}
                                    />
                                </div>
                                <div className='d-flex align-items-center'>
                                    <label htmlFor='cc' className='pe-2' style={{width: '5em'}}>CC:</label>
                                    <ClientEmailInput getValues={getValues} setValue={setValue} register={register}
                                                      autoFocus={false} required={false} id='cc'
                                                      emailContactList={emailContactList}
                                                      fieldName={'emailCCRecipients'}/>
                                </div>

                                <datalist id='emails'>
                                    {emailContactList?.map(c => <option
                                        value={c.email}>{c.name}</option>)}
                                </datalist>
                                <Subject subjectFields={subjectFields} register={register} name={'emailSubject'}/>
                            </fieldset>
                        </div>
                        <div className='form-control h-auto overflow-auto transmittalHtml'
                             style={{flexGrow: 100}}
                             dangerouslySetInnerHTML={{__html: transmittalHtml}}>
                        </div>
                    </form>
                </div>
            </dialog>
        </div>
    )

}

window["renderTransmittalSendEmail"] = function (props: transmittalSendDto) {
    createRoot(document.querySelector('#sendEmailWidget')).render(
        <SendEmail
            {...props}
            rootUrl={'/transmittal/' + props.transmittalId}
            loading={false}
            errHandler={() => {
                return
            }}
            resHandler={() => {
                return
            }}
            disabled={false}
        />);

}
